import type { Store } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { persistSlicesOnChange } from "@/Helpers/persistSlicesOnChange";
import { rootReducer } from "@/rootReducer";

export const store: Store = configureStore({
  reducer: rootReducer,
});

persistSlicesOnChange(store);

export type RootState = ReturnType<typeof rootReducer>;
